<template>
  <main @touchmove.capture="dialogTouchMove($event)">
    <div class="shield-box">
      <div class="mask" @click="close"></div>
      <div class="shield-cnt">
        <h3 class="title flex">选择屏蔽理由<span class="black-btn" @click="goodsBlack">商品黑名单</span></h3>
        <section class="shield-list" @click="listClick($event)">
          <ul>
            <li class="list-item" data-attr-type="0">不感兴趣</li>
            <li class="list-item" data-attr-type="1">商品类型重复</li>
            <li class="list-item" data-attr-type="2">图片引起不适</li>
          </ul>
        </section>
        <i class="iconfont icon-guanbi" @click="close"></i>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { BlockProductAdd } from '@/api/souhuo'
import { Toast, Indicator } from 'mint-ui'

export default {
  computed: {
    ...mapGetters(['getCurOperateProductId'])
  },
  methods: {
    ...mapMutations(['HAD_SHIELD', 'SHIELD_DIALOG_SHOW', 'CUR_PRODUCT_ID']),
    dialogTouchMove (e) {
      e.preventDefault()
    },
    goodsBlack () {
      this.SHIELD_DIALOG_SHOW(false)
      this.$router.push({ name: 'goodsBlacklist' })
    },
    listClick (e) {
      let shieldType = Number(e.target.getAttribute('data-attr-type')) || 0
      if (!this.getCurOperateProductId) {
        Toast('出错啦~无商品ID')
        return
      }
      this.SHIELD_DIALOG_SHOW(false)
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      BlockProductAdd({
        ProductID: this.getCurOperateProductId,
        BlockProductReason: shieldType
      }).then(res => {
        Indicator.close()
        Toast('该商品将不再展现')
        this.CUR_PRODUCT_ID(null)
        this.HAD_SHIELD(true)
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    close () {
      this.CUR_PRODUCT_ID(null)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .shield-box{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
  }
  .mask{
    background: #000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
    opacity: 0.7;
  }
  .shield-cnt{
    position: relative;
    width: 80%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 20px;
    z-index: 999;
    background: #fff;
    border-radius: 5px;
    font-size: 15px;
    animation: dialog-enter 0.3s ease-out;
  }
  .shield-cnt .black-btn{
    display: inline-block;
    font-weight: normal;
    margin-left: auto;
    font-size: 12px;
    border: 1px solid #ccc;
    padding: 1px 10px;
    line-height: 22px;
    border-radius: 15px;
    box-sizing: border-box;
  }
  .black-btn:active{background: #f5f5f5;}
  .shield-list{
    margin-top: 20px;
  }
  .shield-list .list-item{
    height: 45px;
    line-height: 45px;
    transition: background 0.2s ease-out;
  }
  .shield-list .list-item:active{background: #f5f5f5;}
  .shield-cnt .iconfont{
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 30px;
  }
  @keyframes dialog-enter {
    from {
      transform: scale(0.7);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
